import React from 'react'
import { Redirect, Route } from 'react-router'

interface Props {
  [key: string]: unknown
}
const isAuth = window.localStorage.getItem('ACCESS_TOKEN')

const PrivateRoute: React.FC<Props> = ({ children, ...rest }) => {
  return isAuth ? <Route {...rest}>{children}</Route> : <Redirect to='/login' />
}

export default PrivateRoute
